import { render, staticRenderFns } from "./ModuleMenuDrawer.vue?vue&type=template&id=25755862&scoped=true"
import script from "./ModuleMenuDrawer.vue?vue&type=script&lang=js"
export * from "./ModuleMenuDrawer.vue?vue&type=script&lang=js"
import style0 from "./ModuleMenuDrawer.vue?vue&type=style&index=0&id=25755862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25755862",
  null
  
)

export default component.exports